import { noop } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { injectIntl, defineMessages } from 'react-intl';
import { GenderFilterEnum } from '../../../../constants';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.Gender.Title',
        defaultMessage: `{count, plural,
            =0 {doctor's gender}
            other {doctor's gender (#)}
        }`,
    },
    Any: {
        id: 'Components.RefineSearch.Gender.Any',
        defaultMessage: 'any gender',
    },
    Male: {
        id: 'Components.RefineSearch.Gender.Male',
        defaultMessage: 'male',
    },
    Female: {
        id: 'Components.RefineSearch.Gender.Female',
        defaultMessage: 'female',
    },
});

const GenderFilter = ({
    defaultOpen,
    genderFilter,
    intl,
    numApplied,
    onChangeCallback,
    trackRefineSearchClickGender,
}) => {
    const title = intl.formatMessage(LOCALIZED_STRINGS.Title, {
        count: numApplied,
    });

    const anyGender = intl.formatMessage(LOCALIZED_STRINGS.Any);
    const female = intl.formatMessage(LOCALIZED_STRINGS.Female);
    const male = intl.formatMessage(LOCALIZED_STRINGS.Male);

    const onChange = update => {
        if (update !== genderFilter) {
            onChangeCallback({ genderFilter: update });
            trackRefineSearchClickGender(update);
        }
    };

    return (
        <CollapsibleSection
            data-test="search-refine-gender-filter"
            defaultOpen={defaultOpen}
            headerText={title}
        >
            <RadioGroup
                flush
                name="gender"
                onChangeCallback={onChange}
                renderWithoutBox
                selectedValue={genderFilter}
            >
                <Radio
                    data-test="search-refine-gender-filter-anygender"
                    text={anyGender}
                    value={GenderFilterEnum.AnyGender}
                />
                <Radio
                    data-test="search-refine-gender-filter-female"
                    text={female}
                    value={GenderFilterEnum.Female}
                />
                <Radio
                    data-test="search-refine-gender-filter-male"
                    text={male}
                    value={GenderFilterEnum.Male}
                />
            </RadioGroup>
        </CollapsibleSection>
    );
};

GenderFilter.propTypes = {
    defaultOpen: PropTypes.bool,
    genderFilter: PropTypes.string.isRequired,
    numApplied: PropTypes.number,
    onChangeCallback: PropTypes.func.isRequired,
    trackRefineSearchClickGender: PropTypes.func,
};

GenderFilter.defaultProps = {
    trackRefineSearchClickGender: noop,
};

export default injectIntl(GenderFilter);
